import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleShowInMap } from "./../../../store/actions/group.action";
import { toggleSelectedVehicle } from "../../../store/actions/report.action";
import { CircularProgressbar } from "react-circular-progressbar";
import Card from "../../UI/Card";
import Checkbox from "../../UI/CheckBox";

const Vehicle = ({
  vehicle,
  activeVehicle,
  totalUsedStorage,
  totalVehiclesStorage,
  onVehicleSelected,
}) => {
  const loadImage = (category) => {
    if (category == "arrow") category = "Arrow";
    try {
      if (category) {
        return require(`../../../assets/images/vehicles_icon/type${category.toLowerCase()}.svg`)
          .default;
      } else {
        return require("../../../assets/images/vehicles_icon/typecar.svg")
          .default;
      }
    } catch (error) {
      return require("../../../assets/images/vehicles_icon/typecar.svg")
        .default;
    }
  };
  const [vehicleIcon, setVehicleIcon] = useState("");

  const getUsedStorage = () => {
    var usedStorage = 0;

    if (totalUsedStorage && totalVehiclesStorage) {
      usedStorage = ((totalUsedStorage / totalVehiclesStorage) * 100).toFixed(
        2
      );
    }
    return usedStorage;
  };

  // useEffect(() => {
  //   const isSelected = selectedVehicles.findIndex((v) => v.id == vehicle.id);
  //   if (isSelected !== -1) {
  //     setChecked(true);
  //   } else {
  //     setChecked(false);
  //   }
  // }, [selectedVehicles, vehicle]);

  useEffect(() => {
    setVehicleIcon(loadImage(vehicle.category));
  }, [vehicle]);

  return (
    <Card
      onClick={(e) => onVehicleSelected(vehicle.id)}
      style={styles.card}
      className={`hover-outline-task v-center px-2 mt-1
        ${vehicle.id == activeVehicle ? "active-card" : null}
        `}
    >
      <div className="row m-0">
        <div className="col-12 d-flex justify-content-between p-0">
          <div className="pr-0 lex-grow-1 d-flex">
            {/* <Checkbox
              checked={checked}
              //   id={props.driver._id}
              onChange={handleMapCheckbox}
              className="chk-white mr-2 ml-1"
              labelClass="mb-0 mt-1"
            /> */}
            <div className="my-auto">
              <img
                alt="small outline of the vehicle"
                className={`acrdl-v-i ${
                  vehicle.category?.toLowerCase() == "arrow" ? "arrow" : ""
                }`}
                src={vehicleIcon}
              />
            </div>
            <div className="flex-1 mx-2 my-auto">
              <p
                className="font-weight-500 ellipsis-250 font-14"
                style={{ color: "#428bca" }}
              >
                {vehicle.name}
              </p>
            </div>
          </div>
          <div className="my-auto" style={{ height: 40, width: 40 }}>
            <CircularProgressbar
              maxValue={100}
              value={getUsedStorage()}
              text={`${getUsedStorage()}%`}
            />
          </div>
        </div>
      </div>
    </Card>
  );
};

const styles = {
  card: {
    marginBottom: "5px",
    boxShadow: "none",
    cursor: "pointer",
    padding: "5px",
    // height: 43
  },
};
export default Vehicle;
